module.exports = __webpack_public_path__ + "static/media/9DESA29.4ff3416e.jpg";